import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import DocumentsTable from "../../apiTables/DocumentsTable";

const DocumentsPage = ({geoIds}) => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <DocumentsTable geoIds={geoIds}/>
                </div>
            </div>
        </div>
    );
};

export default DocumentsPage;
